import React from 'react';
import { Check, X } from 'lucide-react';

// Presence colors (same green / red as the original DN presence grid).
const PRESENT = { background: '#dcfce7', color: '#15803d' };
const ABSENT = { background: '#fee2e2', color: '#b91c1c' };

/**
 * Presence heat cell: green ✓ (present), red ✗ (audited/seen but absent), grey — (not audited that month).
 */
export function PresenceCell({ audited, present }) {
    if (!audited) return <div className="heat-cell text-surface-300">—</div>;
    return present ? (
        <div className="heat-cell font-bold" style={PRESENT} title="Presente">
            <Check />
        </div>
    ) : (
        <div className="heat-cell font-bold" style={ABSENT} title="Ausente">
            <X />
        </div>
    );
}

/** Legend for presence grids. `missing` (optional) describes the "—" cell. */
export function PresenceLegend({ missing }) {
    return (
        <span className="inline-flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-surface-500">
            <span className="inline-flex items-center gap-1.5">
                <span className="flex h-4 w-4 items-center justify-center rounded-sm text-[11px]" style={PRESENT}>
                    <Check />
                </span>
                presente
            </span>
            <span className="inline-flex items-center gap-1.5">
                <span className="flex h-4 w-4 items-center justify-center rounded-sm text-[11px]" style={ABSENT}>
                    <X />
                </span>
                ausente
            </span>
            {missing ? <span className="inline-flex items-center gap-1.5">{missing}</span> : null}
        </span>
    );
}
